export default __webpack_public_path__ + "static/shruteeGanguly-9f013d284a979a0a67694871e148270b.jpg";